<template>
  <b-card>
    <b-row align-h="between">
      <b-col>
        <h4>Evolution de la population</h4>
      </b-col>
      <b-col cols="3" class="text-right">
        <b-avatar
          size="32"
          variant="light-primary"
          v-b-tooltip.hover.v-primary
          title="Cet indicateur illustre l’évolution de la population totale du secteur du programme ou adresse sélectionné pour les 4 dernières années jusqu’au dernier recensement."
        >
          <feather-icon size="20" icon="HelpCircleIcon" />
        </b-avatar>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="7">
        <population-trend-chart
          :demographyByPeriode="reportData.demographyByPeriode[0]"
        />
      </b-col>
      <b-col xl="5">
        <population-trend-array
          :demographyByPeriode="reportData.demographyByPeriode[0]"
        />
      </b-col>
      <b-col xl="12">
        <comment-form-text-area
          :enable="reportData.comments.populationTrend.enable"
          :commentField="reportData.comments.populationTrend.value"
          v-on:update:comment="
            reportData.comments.populationTrend.value = $event
          "
          v-on:update:enable="
            reportData.comments.populationTrend.enable = $event
          "
          v-on="$listeners"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, VBTooltip, BAvatar } from "bootstrap-vue";
import PopulationTrendChart from "./population-trend-elements/PopulationTrendChart";
import PopulationTrendArray from "./population-trend-elements/PopulationTrendArray";
import CommentFormTextArea from "../../shared/CommentFormTextArea";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,

    PopulationTrendChart,
    PopulationTrendArray,
    CommentFormTextArea,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    reportData: {
      type: Object,
      required: true,
    },
  },
};
</script>
